import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { UserConstant } from '../constants/user-constant';

@Injectable({ providedIn: 'root' })
export class CellularBillingRootGuard implements CanActivate {
  constructor(private router: Router) { }

  canActivate(): boolean {
    let user;
    try {
      const storedUser = localStorage.getItem(UserConstant.USER);
      user = storedUser ? JSON.parse(storedUser) : null;
    } catch (_) {
      user = null;
    }
    if (user && Number(user.role) === 0) return true;
    this.router.navigate(['/layout']);
    return false;
  }
}
